import React from "react";
import { Row, Col } from "react-bootstrap";
import "./style.scss";

const CardList = (props) => {
  return (
    <Row className="list-reminder" onClick={props.onClick}>
      <Col xs={7} sm={7} md={7} className="event">
        <div className="detail">
          <img src={props.icons} alt="icon_next" />
          <div className="text-wrapper">
            <div className="text-title">{props.title}</div>
            <div className="text-time">{props.time}</div>
          </div>
        </div>
      </Col>
      <Col xs={5} sm={5} md={5} className="date">
        <span>{props.date}</span>
      </Col>
      <div className="line" />
    </Row>
  );
};

export default CardList;
